import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class EditImage extends Component {
  static propTypes = {
    src: PropTypes.string.isRequired,
    degree: PropTypes.number,
    onClick: PropTypes.func,
  }
  constructor(props) {
    super(props);
    const degree = props.degree || 0;
    this.state = {
      degree,
      image: null,
    };
    this.canvas = null;
    this.hasClick = false;
  }
  componentDidMount() {
    this.getOnClick();
    this.updateCanvas();
  }
  componentWillReceiveProps(nextProps) {
    const degree = nextProps.degree;
    if (this.props.src !== nextProps.src) {
      this.setState({
        image: null,
      }, () => {
        this.updateCanvas();
      });
    }
    this.setState({ degree });
  }
  componentDidUpdate() {
    this.updateCanvas();
  }
  componentWillUnmount() {
    this.removeOnClick();
  }
  getOnClick() {
    if (this.props.onClick) {
      const canvas = this.canvas;
      canvas.addEventListener('click', this.handleOnClick, false);
      this.hasClick = true;
    }
  }
  removeOnClick() {
    if (this.hasClick) {
      const canvas = this.canvas;
      canvas.removeEventListener('click', this.handleOnClick, false);
    }
  }
  handleOnClick = (e) => {
    if (this.props.onClick) {
      this.props.onClick(e);
    }
  }
  updateCanvas() {
    const canvas = this.canvas;
    const ctx = canvas.getContext('2d');
    const max = canvas.width > canvas.height ? canvas.width : canvas.height;
    ctx.clearRect(0, 0, max, max);
    // draw image
    if (!this.state.image) {
      const image = new Image();
      image.src = this.props.src;
      image.onload = () => {
        image.height = (450 * image.height) / image.width;
        image.width = 450;
        canvas.width = image.width;
        canvas.height = image.height;
        ctx.drawImage(image, 0, 0, image.width, image.height);
      };
      this.setState({ image });
    } else {
      this.rotate(this.state.degree);
    }
  }
  rotate = (degree) => {
    this.changeCanvasSize(degree);
    this.drawImage(degree);
  }
  changeCanvasSize(degree) {
    const { image } = this.state;
    if (degree === 0 || degree === 180) {
      this.canvas.width = image.width;
      this.canvas.height = image.height;
    } else {
      this.canvas.width = image.height;
      this.canvas.height = image.width;
    }
  }
  drawImage(degree) {
    const canvas = this.canvas;
    const ctx = canvas.getContext('2d');
    const { image } = this.state;
    ctx.save();
    ctx.translate(canvas.width / 2, canvas.height / 2);
    ctx.rotate((degree * Math.PI) / 180);
    ctx.drawImage(image, -image.width * 0.5, -image.height * 0.5, image.width, image.height);
    ctx.restore();
  }
  render() {
    return (
      <canvas
        className="center"
        ref={(ref) => { this.canvas = ref; }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EditImage.jsx